import React from 'react';
import Select from 'component/atom/forms/select/select/Select';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { usePost } from 'hooks/usePost';
import styles from './CreateFolderForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import Input from 'component/atom/forms/input/input/Input';
import { knowledgeBase } from 'hooks/endpoints';
import { knowledgeBaseToast } from 'helpers/toastMessages';
import { useUserContext } from 'app-context/user/UserContext';
import { useToast } from 'app-context/toasterContext/ToastContext';

const Form = ({ formik }) => {
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className={styles['form']}
    >
      <Input
        label='Folder Name'
        placeholder='Enter folder name'
        name='folderName'
        value={formik.values.folderName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.folderName && formik.errors.folderName}
      />
      <Button
        type='save'
        label='Save'
        inputType='submit'
        isLoading={formik.isSubmitting}
        disabled={formik.isSubmitting}
        onClick={formik.handleSubmit}
      />
    </form>
  );
};

const CreateFolder = ({ isOpen, onClose, selectedItems, setRefetch }) => {
  const { selectedBot } = useUserContext();
  const toast = useToast();
  const { mutate: createFolder, isPending } = usePost({
    onSuccessToast: knowledgeBaseToast.create,
    toastType: 'add',
  });

  const validationSchema = Yup.object({
    folderName: Yup.string().required('Folder Name is required'),
  });

  const formik = useFormik({
    initialValues: {
      folderName: '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const invalidFolderName = /[^A-Za-z0-9]/.test(values.folderName);

      if (invalidFolderName) {
        toast.open(
          'Folder name cannot contain spaces or special characters. Please enter a valid name.',
          'error'
        );
        setSubmitting(false);
        return;
      }
      createFolder(
        {
          url: knowledgeBase.newFolder(
            `?FolderName=${values.folderName}&BotId=${selectedBot?.botId}`
          ),
        },
        {
          onSuccess: () => {
            setRefetch(true);
            onClose();
          },
          onError: (error) => {
            console.error('Error creating folder:', error);
          },
          onSettled: () => {
            setSubmitting(false);
          },
        }
      );
    },
    enableReinitialize: true,
  });

  return (
    <div>
      <Modal
        title='New Folder'
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        isLoading={isPending}
      >
        <Form formik={formik} />
      </Modal>
    </div>
  );
};

export default CreateFolder;
